import type { IconProps } from "./types";

export function PieChart({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.84888 3.07617C8.30422 2.877 8.83517 3.08475 9.03442 3.54004C9.23331 3.99525 9.02561 4.52535 8.57056 4.72461C7.38082 5.24508 6.33577 6.05048 5.52759 7.06934C4.71947 8.08823 4.1717 9.29031 3.93384 10.5703C3.69602 11.8505 3.77511 13.1705 4.16333 14.4131C4.55158 15.6555 5.23804 16.7842 6.16138 17.6992C7.08463 18.614 8.21745 19.2884 9.46021 19.6631C10.7033 20.0377 12.0199 20.1013 13.2932 19.8486C14.5664 19.5959 15.7589 19.0342 16.7659 18.2129C17.773 17.3913 18.5646 16.334 19.0706 15.1348C19.2638 14.6772 19.7915 14.4626 20.2493 14.6553C20.7072 14.8485 20.922 15.377 20.7288 15.835C20.1087 17.3045 19.1385 18.6 17.9036 19.6074C16.6686 20.6147 15.206 21.3041 13.6438 21.6143C12.0816 21.9243 10.4667 21.8463 8.94165 21.3867C7.41648 20.927 6.02608 20.0996 4.8938 18.9775C3.76154 17.8554 2.92031 16.4718 2.44458 14.9492C1.96901 13.4268 1.873 11.8105 2.16431 10.2422C2.4557 8.67368 3.12666 7.20036 4.11743 5.95117C5.1082 4.70207 6.38933 3.7147 7.84888 3.07617ZM11.8997 2C13.1994 2 14.4869 2.25661 15.6877 2.75391C16.8888 3.25139 17.9804 3.9812 18.8997 4.90039C19.8189 5.81965 20.5486 6.91124 21.0461 8.1123C21.5435 9.3133 21.8 10.6005 21.8 11.9004C21.8 12.3974 21.3967 12.8008 20.8997 12.8008H11.8997C11.4028 12.8005 10.9993 12.3973 10.9993 11.9004V2.90039C10.9993 2.6618 11.0943 2.43243 11.2629 2.26367C11.4316 2.095 11.6611 2.00012 11.8997 2ZM12.8 11H19.9475C19.8631 10.2455 19.6747 9.50493 19.3831 8.80078C18.976 7.81811 18.3793 6.92497 17.6272 6.17285C16.8751 5.4208 15.9819 4.82401 14.9993 4.41699C14.2952 4.12542 13.5544 3.93694 12.8 3.85254V11Z"
        fill={currentColor}
      />
    </svg>
  );
}
